import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import EmployeeDashboardPage from "@/pages/employee/EmployeeDashboardPage";

export const Route = createFileRoute("/employee/dashboard")({
  head: () => pageHead("Employee · Dashboard", "AKIVA employee · dashboard portal.", "/employee/dashboard", true),
  component: EmployeeDashboardPage,
});
